(() => {
  const zone = 'Europe/Amsterdam';
  const dayMs = 86400000;
  const parts = date => Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone: zone, year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(date).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
  const civil = date => { const p=parts(date); return new Date(Date.UTC(p.year,p.month-1,p.day)); };
  const key = date => date.toISOString().slice(0,10);
  const add = (date,n) => new Date(date.getTime()+n*dayMs);
  const easter = year => {
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),month=Math.floor((h+l-7*m+114)/31),day=(h+l-7*m+114)%31+1;
    return new Date(Date.UTC(year,month-1,day));
  };
  const holiday = date => {
    const y=date.getUTCFullYear(),e=easter(y),kings=new Date(Date.UTC(y,3,27));
    if(kings.getUTCDay()===0) kings.setUTCDate(26);
    return [new Date(Date.UTC(y,0,1)),kings,new Date(Date.UTC(y,4,5)),new Date(Date.UTC(y,11,25)),new Date(Date.UTC(y,11,26)),...[-2,0,1,39,49,50].map(n=>add(e,n))].some(d=>key(d)===key(date));
  };
  const instant = (date,hour) => {
    const target=Date.UTC(date.getUTCFullYear(),date.getUTCMonth(),date.getUTCDate(),hour);
    let guess=target;
    for(let n=0;n<3;n++){const p=parts(new Date(guess));guess+=target-Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);}
    return new Date(guess);
  };
  const calculate = (now,options={}) => {
    const today=civil(now),closed=new Set(options.closed||[]),cutoff=Number(options.cutoff??16),transit=Number(options.transit??1);
    const unavailable=d=>holiday(d)||closed.has(key(d));
    const dispatchDay=d=>d.getUTCDay()>0&&d.getUTCDay()<6&&!unavailable(d);
    const cutoffFor=d=>d.getUTCMonth()===11&&[24,31].includes(d.getUTCDate())?Math.max(0,cutoff-2):cutoff;
    let dispatch=today;
    for(let n=0;n<370;n++){
      if(dispatchDay(dispatch)&&now<instant(dispatch,cutoffFor(dispatch)))break;
      dispatch=add(dispatch,1);
    }
    let delivery=dispatch,remaining=transit;
    while(remaining>0){delivery=add(delivery,1);if(delivery.getUTCDay()!==0&&!unavailable(delivery))remaining--;}
    return {dispatch,delivery,cutoff:instant(dispatch,cutoffFor(dispatch)),sameDay:key(dispatch)===key(today),tomorrow:key(delivery)===key(add(today,1))};
  };
  if(typeof module!=='undefined'&&module.exports)module.exports={calculate,holiday,instant};
  if(typeof window==='undefined')return;
  if(customElements.get('vacdra-delivery-countdown'))return;
  customElements.define('vacdra-delivery-countdown',class extends HTMLElement{
    connectedCallback(){
      this.config=JSON.parse(this.querySelector('[data-delivery-config]').textContent);
      this.update=this.update.bind(this);
      this.addEventListener('change',this.update);
      this.scope=this.closest('product-info')||this.closest('section')||document;
      this.scope.addEventListener('change',this.update);
      this.visibility=()=>{if(!document.hidden)this.update();};
      document.addEventListener('visibilitychange',this.visibility);
      this.interval=setInterval(this.update,1000);
      this.update();
    }
    disconnectedCallback(){clearInterval(this.interval);this.scope?.removeEventListener('change',this.update);document.removeEventListener('visibilitychange',this.visibility);}
    update(){
      const c=this.config;
      const id=this.scope.querySelector('form[action*="/cart/add"] input[name="id"]')?.value||c.selected;
      const variant=c.variants.find(v=>String(v.id)===String(id));
      if(!variant?.ready){this.hidden=true;return;}
      const now=new Date(),result=calculate(now,c),minutes=Math.max(1,Math.ceil((result.cutoff-now)/60000));
      const hours=Math.floor(minutes/60),mins=minutes%60;
      const duration=[hours?hours+' '+c.hours:'',mins+' '+c.minutes].filter(Boolean).join(' ');
      const formatted=new Intl.DateTimeFormat(c.locale,{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(result.delivery);
      const date=(result.tomorrow?c.tomorrow+', ':'')+formatted;
      this.querySelector('[data-delivery-date]').textContent=c.expected.replace('__DATE__',date);
      this.querySelector('[data-delivery-duration]').textContent=duration;
      this.querySelector('[data-delivery-countdown-line]').hidden=false;
      const dispatchLine=this.querySelector('[data-delivery-dispatch]');
      dispatchLine.hidden=true;
      dispatchLine.textContent=c.dispatches.replace('__DAY__',new Intl.DateTimeFormat(c.locale,{timeZone:'UTC',weekday:'long'}).format(result.dispatch));
      this.hidden=false;
    }
  });
})();


